const state = {
  env: {}
}
const mutations = {
  setEnv (state, env) {
    state.env = env
  }
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
